export const PRODUCT_IDS = {
    GASOLINA: 1,
    ETANOL: 2,
    DIESEL: 3,
    GASOLINA_ADV: 4,
    DIESEL_S10: 11,
    ARLA_32: 12,
    GNV: 13,
    S10_ADV: 30,
    ETANOL_ADV: 38,
} as const;

export const PRODUCT_PRICE_MAP: Record<number, keyof any> = {
    [PRODUCT_IDS.GASOLINA]: 'gasolina',
    [PRODUCT_IDS.ETANOL]: 'estanol',
    [PRODUCT_IDS.DIESEL]: 'diesel',
    [PRODUCT_IDS.DIESEL_S10]: 'diesel_s10',
    [PRODUCT_IDS.GASOLINA_ADV]: 'gasolina_adv',
    [PRODUCT_IDS.S10_ADV]: 's10_adv',
    [PRODUCT_IDS.ARLA_32]: 'arla_32',
    [PRODUCT_IDS.ETANOL_ADV]: 'etanol_adv',
    [PRODUCT_IDS.GNV]: 'gnv',
};

